<app-duna-catering-wishes
  [eventId]="data.row.event_id"
  [eventMeta]="eventMeta"
  [showCloseButton]="true"
  (closeRequested)="close()">
</app-duna-catering-wishes>
